import React, { useState } from 'react';
import "./ChatScreen.css";
import Avatar from "@material-ui/core/Avatar";

function ChatScreen() {
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([
        {
            name: "Markos",
            image: "https://cdn3.iconfinder.com/data/icons/avatars-round-flat/33/man7-128.png",
            message: "Hello there",
        },
        {
            name: "Markos",
            image: "https://cdn3.iconfinder.com/data/icons/avatars-round-flat/33/man7-128.png",
            message: "Hello What's going on?",
        },
        {
            message: "Hello yourself, All is well!! 😎🤣",
        },
    ])


    const handleSend = e => {
        e.preventDefault();
        setMessages([...messages, { message: input }]);
        setInput('');
    }
    return (
        <div className="chatScreen">
            <p className="chatScreen__timestamp">You matched with Sandra on Jan 23, 2021</p>
            {messages.map(message =>
                message.name ? (

                    <div className="chatScreen__message">
                        <Avatar
                            className="chatScreen__image"
                            src={message.image}
                            alt={message.name}

                        />
                        <p className="chatScreen__text">{message.message}</p>
                    </div>
                ) : (
                        <div className="chatScreen__message">

                            <p className="chatScreen__textUser">{message.message}</p>
                        </div>
                    )
            )}

            <form className="chatScreen__input">
                <input className="chatScreen__inputField" placeholder="Type a message..." value={input} onChange={e => setInput(e.target.value)} type="text" />
                <button className="chatScreen__inputButton" onClick={handleSend} type="submit">SEND</button>
            </form>

        </div>
    );
}

export default ChatScreen
